define( [ "./selector-sizzle" ], function() {
	"use strict";
} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/selector.js
// module id = 22
// module chunks = 80